import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


export function ScoreContainer(props) {
  const { resultObj, matchHasIrm } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const result = resultObj?.result ? resultObj.result : resultObj?.extra?.resultCurrent ? resultObj.extra?.resultCurrent : '\u00A0';

  return (
    <div className="score-result-container flex-row justify-content-end d-flex flex-nowrap w-100">
      <div className={`col-2 p-0 text-end ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
        {result}
      </div>
      {resultObj?.extra?.resultG1 && <div className="score-result ">{resultObj?.extra?.resultG1}</div>}
      {resultObj?.extra?.resultG2 && <div className="score-result ">{resultObj?.extra?.resultG2}</div>}
      {resultObj?.extra?.resultG3 && <div className="score-result ">{resultObj?.extra?.resultG3}</div>}
      {matchHasIrm && !resultObj?.hasIRM && <div className="match-irm fw-bold "></div>}
      {resultObj?.hasIRM &&
        <div className="text-start match-irm fw-bold align-self-center" style={{ marginLeft: '5px', width: '30px' }}>
          <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
        </div>
      }

    </div>
  )
}